export default __webpack_public_path__ + "static/media/tai_lieu_tap_huan_2022.931efcda.png";